import React, { FC, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Checkbox from '@app/components/Checkbox/Checkbox'
import S from './CookieConsent.styles'
import useCookieConsent from './useCookieConsent'
import { STORAGE_KEY } from './constants'

const CookiePreferences: FC = () => {
  const ctx = useCookieConsent()
  const { messages } = useIntl()
  const consent = ctx.getConsent()
  const [stagedConsent, setStagedConsent] = useState(consent)

  const groups = [
    {
      id: 'essential',
      title: messages['static.page.cookie_consent.essential_title'] as string,
      description: messages['static.page.cookie_consent.essential_desc'] as string,
    },
    {
      id: 'performance',
      title: messages['static.page.cookie_consent.performance_title'] as string,
      description: messages['static.page.cookie_consent.performance_desc'] as string,
    },
    {
      id: 'functional',
      title: messages['static.page.cookie_consent.functional_title'] as string,
      description: messages['static.page.cookie_consent.functional_desc'] as string,
    },
    {
      id: 'targetting',
      title: messages['static.page.cookie_consent.targetting_title'] as string,
      description: messages['static.page.cookie_consent.targetting_desc'] as string,
    },
  ]

  useEffect(() => {
    // Check if user has already given consent
    const storedConsent = localStorage.getItem(STORAGE_KEY)
    if (storedConsent) {
      ctx.updateConsent(JSON.parse(storedConsent))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleConsent = (groupId: string, value: boolean) => {
    setStagedConsent({ ...stagedConsent, [groupId]: value })
  }

  const consentToAll = () => {
    const opts = {
      essential: true,
      performance: true,
      functional: true,
      targetting: true,
    }

    ctx.updateConsent(opts)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(opts))
    ctx.closePreferences()
  }

  const consentToSelected = () => {
    ctx.updateConsent(stagedConsent)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stagedConsent))
    ctx.closePreferences()
  }

  return (
    <S.Backdrop>
      <S.Dialog initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
        <S.Content>
          {groups.map(g => (
            <S.Preference key={g.id}>
              <S.PreferenceHeader>
                <FormattedMessage id={g.title} tagName="h4" />
                <Checkbox
                  id={g.id}
                  name={`accept${g.id}`}
                  value="test"
                  checked={stagedConsent[g.id as keyof typeof stagedConsent]}
                  onChange={e => handleConsent(g.id, e.target.checked)}
                  disabled={g.id === 'essential'}
                />
              </S.PreferenceHeader>
              <FormattedMessage id={g.description} tagName="p" />
            </S.Preference>
          ))}
          <S.Actions>
            <button type="button" aria-label="allow_selected" className="reverse" onClick={consentToSelected}>
              <FormattedMessage id="static.page.cookie_consent.allow_selected" />
            </button>
            <button type="button" aria-label="cookie_allow" onClick={consentToAll}>
              <FormattedMessage id="static.page.cookie_consent.allow_all" />
            </button>
          </S.Actions>
        </S.Content>
      </S.Dialog>
    </S.Backdrop>
  )
}

export default CookiePreferences
